import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TipoContratoService } from '../../services/tipo-contrato.service';
import { AuthService } from '../../services/auth.service';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { LocalizationService } from '../../services/localization.service';
import * as moment from 'moment';

@Component({
  selector: 'app-tipo-contrato-edit',
  templateUrl: './tipo-contrato-edit.component.html',
  styleUrls: ['./tipo-contrato-edit.component.scss']
})
export class TipoContratoEditComponent implements OnInit {

  tipoContratoForm: FormGroup;
  title = 'Crear';
  isNewElement: boolean;

  id: number;
  isModal: boolean;
  errorMessage: any;

  options: any = {
    format: 'DD/MM/YYYY HH:mm z'
  };

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, private localization: LocalizationService,
    private _TipoContratoService: TipoContratoService, private _authService: AuthService, private _router: Router,
    public dialogRef: MatDialogRef<TipoContratoEditComponent>,
    private _location: Location) {



    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    }

    this.tipoContratoForm = this._fb.group({
      id: 0,
      nombreContrato: ['', Validators.required],
      nombreContrato_PT: ['', Validators.required],
      createdBy: [''],
      updatedBy: [''],
      updatedDate: [''],
      createdDate: [new Date],
      createdByName: [''],
      updatedByName: ['']
    });
  }

  ngOnInit() {
    if (this.id > 0) {
      this.isNewElement = false;
      this.title = "Editar";
      this._TipoContratoService.getTipoContratoByID(this.id)
        .subscribe(resp => {
          this.tipoContratoForm.setValue(resp);
        }
          , error => {
            this.errorMessage = error;
            console.log(error);
          });
    }
    else {
      this.isNewElement = true;
    }
  }

  public moment(data) {
    if (data == "" || data == null) {
      return null;
    }
    return moment.utc(data).local().format('DD/MM/YYYY HH:mm');
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal)
      this._location.back();
    else
      this.closeDialog();
  }

  save() {
    if (!this.tipoContratoForm.valid) {
      return;
    }

    if (this.isNewElement) {
      this._TipoContratoService.createTipoContrato(this.tipoContratoForm.value)
        .subscribe((data) => {
          if (!this.isModal)
            this._location.back();
          else
            this.closeDialog();
        }, error => this.errorMessage = error)
    }
    else {
      this._TipoContratoService.updateTipoContrato(this.tipoContratoForm.value)
        .subscribe((data) => {
          if (!this.isModal)
            this._location.back();
          else
            this.closeDialog();
        }, error => this.errorMessage = error)
    }
  }

  get nombreContrato() { return this.tipoContratoForm.get('nombreContrato') };
  get nombreContrato_PT() { return this.tipoContratoForm.get('nombreContrato_PT') };
}
